(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-turntable"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.fyt');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const products = JSON.parse(root.querySelector('.fyt__products').textContent || '{}');
      const config = JSON.parse(root.querySelector('.fyt__config').textContent || '{}');
      const stage = root.querySelector('.fyt__stage');
      const progress = root.querySelector('.fyt__progress');
      const step = root.querySelector('.fyt__step');
      const percent = root.querySelector('.fyt__percent');
      const fill = root.querySelector('.fyt__fill');
      const back = root.querySelector('.fyt__back');
      const deckNote = root.querySelector('.fyt__deck-note');
      const handles = Object.keys(products);
      const answers = {};
      const scores = {};
      let index = -1;
      let flow = [];

      const intro = { id: 'context', property: 'Purchase Context', question: "Who's this turntable for?", options: [
        { label: "It's for me", value: 'Self', scores: {} },
        { label: "It's a gift for someone", value: 'Gift', scores: {} }
      ]};
      const paths = {
        Self: [
          { id: 'experience', property: 'Vinyl Experience', question: 'How well do you know vinyl?', options: [
            { label: 'Total beginner. This is my first player', value: 'Beginner', scores: { h009: 2, 'automatic-all-in-one-record-player': 2, '1-by-one-all-in-one-turnatble': 1 } },
            { label: "I've owned a player before", value: 'Returning', scores: { '1-by-one-high-fidelity-all-in-one-vinyl-player': 1, h004: 1 } },
            { label: 'My record collection keeps growing', value: 'Collector', scores: { h004: 2, '1-by-one-stainless-steel-casing-turntable': 2 } }
          ]},
          { id: 'operation', property: 'Operation Preference', question: 'How hands-on do you want to be?', options: [
            { label: 'One-touch start and automatic tonearm', value: 'Automatic', scores: { 'automatic-all-in-one-record-player': 4 } },
            { label: "I'll cue the needle myself", value: 'Manual', scores: { h009: 2, h004: 2, '1-by-one-high-fidelity-all-in-one-vinyl-player': 1 } },
            { label: 'No strong preference', value: 'No preference', scores: { h009: 1, 'automatic-all-in-one-record-player': 1 } }
          ]},
          { id: 'speakers', property: 'Speaker Setup', question: 'How should it fit your sound setup?', options: [
            { label: 'Simple with built-in speakers', value: 'Built-in', scores: { h009: 2, 'automatic-all-in-one-record-player': 2, '1-by-one-high-fidelity-all-in-one-vinyl-player': 2, '1-by-one-all-in-one-turnatble': 2, '1-by-one-stainless-steel-casing-turntable': 2 } },
            { label: 'Room-filling separate speakers', value: 'Separate speakers', scores: { h004: 4 } },
            { label: "I'll connect my current sound system", value: 'Own system', scores: { h004: 2, '1-by-one-stainless-steel-casing-turntable': 1 } }
          ]},
          { id: 'finish', property: 'Preferred Finish', question: 'Which finish belongs in your space?', options: [
            { label: 'Classic black', value: 'Black', scores: { '1-by-one-high-fidelity-all-in-one-vinyl-player': 3, h009: 1, 'automatic-all-in-one-record-player': 1 } },
            { label: 'Clean white', value: 'White', scores: { '1-by-one-all-in-one-turnatble': 4 } },
            { label: 'Warm wood tones', value: 'Wood', scores: { h009: 2, 'automatic-all-in-one-record-player': 2 } },
            { label: 'Brushed metal', value: 'Stainless steel', scores: { '1-by-one-stainless-steel-casing-turntable': 4 } }
          ]}
        ],
        Gift: [
          { id: 'budget', property: 'Budget', question: "What's your gift budget?", options: [
            { label: 'Keep it under about $250', value: 'Under $250', scores: { h009: 2, '1-by-one-all-in-one-turnatble': 2, '1-by-one-high-fidelity-all-in-one-vinyl-player': 2 } },
            { label: 'Around $250-280', value: '$250-280', scores: { '1-by-one-stainless-steel-casing-turntable': 2, 'automatic-all-in-one-record-player': 2 } },
            { label: 'Choose the premium option', value: 'Premium', scores: { 'automatic-all-in-one-record-player': 2, h004: 2, '1-by-one-stainless-steel-casing-turntable': 1 } },
            { label: 'Not sure yet', value: 'Flexible', scores: { 'automatic-all-in-one-record-player': 1 } }
          ]},
          { id: 'recipient', property: 'Gift Recipient', question: 'Who are you shopping for?', options: [
            { label: 'Someone new to vinyl', value: 'New to vinyl', scores: { h009: 2, 'automatic-all-in-one-record-player': 2, '1-by-one-all-in-one-turnatble': 1 } },
            { label: "A music lover who'll really use it", value: 'Music lover', scores: { h004: 2, '1-by-one-high-fidelity-all-in-one-vinyl-player': 1, '1-by-one-stainless-steel-casing-turntable': 1 } },
            { label: 'I just want something impressive', value: 'Unsure', scores: { 'automatic-all-in-one-record-player': 1, '1-by-one-stainless-steel-casing-turntable': 1 } }
          ]},
          { id: 'finish', property: 'Preferred Finish', question: 'Which finish would they love?', options: [
            { label: 'Classic black', value: 'Black', scores: { '1-by-one-high-fidelity-all-in-one-vinyl-player': 3, h009: 1, 'automatic-all-in-one-record-player': 1 } },
            { label: 'Clean white', value: 'White', scores: { '1-by-one-all-in-one-turnatble': 4 } },
            { label: 'Warm wood tones', value: 'Wood', scores: { h009: 2, 'automatic-all-in-one-record-player': 2 } },
            { label: 'Brushed metal', value: 'Stainless steel', scores: { '1-by-one-stainless-steel-casing-turntable': 4 } },
            { label: 'Surprise me', value: 'No preference', scores: {} }
          ]},
          { id: 'occasion', property: 'Gift Occasion', question: "What's the occasion?", options: [
            { label: 'Birthday', value: 'Birthday', scores: {} },
            { label: 'Holiday', value: 'Holiday', scores: {} },
            { label: 'Anniversary', value: 'Anniversary', scores: {} },
            { label: 'Just because', value: 'Just because', scores: {} }
          ]}
        ]
      };

      const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character]);
      const track = (name, data = {}) => {
        try {
          if (typeof window.gtag === 'function') window.gtag('event', name, data);
          else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, ...data }); }
        } catch (error) {}
      };
      const klaviyoTrack = (name, properties) => {
        try {
          if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(name, properties);
          else { window._learnq = window._learnq || []; window._learnq.push(['track', name, properties]); }
        } catch (error) {}
      };
      const updateProgress = () => {
        const current = index + 1;
        const value = Math.round((current / 5) * 100);
        root.dataset.progress = String(index);
        step.textContent = `Question ${current} of 5`;
        percent.textContent = `${value}%`;
        fill.style.width = `${value}%`;
        back.hidden = index <= 0;
      };
      const renderIntro = () => {
        index = -1;
        root.classList.remove('fyt--started');
        root.dataset.progress = '0';
        deckNote.textContent = 'Your answers tune the match';
        progress.hidden = true;
        back.hidden = true;
        stage.innerHTML = `<div class="fyt__screen"><button class="fyt__button" type="button" data-fyt-start>${escapeHtml(config.startCta)} <span>→</span></button></div>`;
        stage.querySelector('[data-fyt-start]').addEventListener('click', () => { root.classList.add('fyt--started'); flow = [intro]; index = 0; track('tt_quiz_start'); renderQuestion(); });
      };
      const choose = (question, option) => {
        answers[question.property] = option.value;
        Object.entries(option.scores).forEach(([handle, value]) => { scores[handle] = (scores[handle] || 0) + value; });
        track('tt_quiz_answer', { question: question.property, answer: option.value });
        if (question.id === 'context') flow = [intro, ...(paths[option.value] || [])];
        if (index < flow.length - 1) { index += 1; renderQuestion(); } else renderResult();
      };
      const renderQuestion = () => {
        progress.hidden = false;
        updateProgress();
        const question = flow[index];
        stage.innerHTML = `<div class="fyt__screen"><h2 class="fyt__question">${escapeHtml(question.question)}</h2><div class="fyt__options">${question.options.map((option, optionIndex) => `<button class="fyt__option" type="button" data-option="${optionIndex}"><span>${escapeHtml(option.label)}</span><span aria-hidden="true">→</span></button>`).join('')}</div></div>`;
        stage.querySelectorAll('[data-option]').forEach((button) => button.addEventListener('click', () => choose(question, question.options[Number(button.dataset.option)])));
      };
      const rankedHandles = () => handles.slice().sort((a, b) => (scores[b] || 0) - (scores[a] || 0));
      const buildReasons = (recommendedHandle) => {
        const reasons = [];
        const productReasons = {
          'automatic-all-in-one-record-player': {
            title: 'Press play. The tonearm handles the rest.',
            body: 'One-touch automatic play, auto return and remote control make vinyl easy to enjoy without babysitting the needle.'
          },
          h004: {
            title: 'A complete stereo setup from the start',
            body: 'The turntable and separate speakers come together as one room-filling listening setup.'
          },
          h009: {
            title: 'A simpler all-in-one step into better vinyl',
            body: 'Built-in speakers keep the setup straightforward, while manual play keeps the record ritual in your hands.'
          },
          '1-by-one-stainless-steel-casing-turntable': {
            title: 'A record player they will want to leave on display',
            body: 'The stainless steel finish gives this all-in-one player the modern, substantial presence you were looking for.'
          },
          '1-by-one-high-fidelity-all-in-one-vinyl-player': {
            title: 'A proper step beyond a suitcase player',
            body: 'It brings the turntable, amplifier and speakers together, so better vinyl does not require a complicated component system.'
          },
          '1-by-one-all-in-one-turnatble': {
            title: 'A brighter take on a proper first player',
            body: 'The white piano-gloss finish feels at home in a modern room, with the convenience of an all-in-one setup.'
          }
        };
        if (productReasons[recommendedHandle]) reasons.push(productReasons[recommendedHandle]);
        const operationReasons = {
          Automatic: { title: 'More listening, less setup', body: 'You want the music to start easily, without turning every record into a technical process.' },
          Manual: { title: 'The ritual is part of the pleasure', body: 'You want the hands-on moment of cueing the needle and settling into the record.' },
          'No preference': { title: 'A balanced overall fit', body: 'You kept operation flexible, so the rest of your listening priorities led the recommendation.' }
        };
        const speakerReasons = {
          'Built-in': { title: 'Ready for music with less equipment', body: 'You chose a simpler setup that keeps speakers and playback together.' },
          'Separate speakers': { title: 'Made to fill the room', body: 'You want a dedicated stereo setup that makes listening feel bigger and more immersive.' },
          'Own system': { title: 'Fits the system you already enjoy', body: 'Your current sound setup stays at the center instead of being replaced.' }
        };
        const experienceReasons = {
          Beginner: { title: 'A welcoming first step into vinyl', body: 'Your first player should feel exciting and approachable, not intimidating.' },
          Returning: { title: 'Easy to enjoy from the first record', body: 'You know the basics already, so the match focuses on getting you back into the music.' },
          Collector: { title: 'A match for a growing collection', body: 'You want a player that feels at home in a listening habit that is already becoming serious.' }
        };
        const recipientReasons = {
          'New to vinyl': { title: 'A gift that makes vinyl easy to love', body: 'Their first player should make the experience feel inviting from day one.' },
          'Music lover': { title: 'Made for everyday listening', body: 'This is not just a display piece. You chose for someone who will make music part of their daily routine.' },
          Unsure: { title: 'A gift with instant presence', body: 'You wanted something that feels special without requiring deep vinyl knowledge.' }
        };
        if (operationReasons[answers['Operation Preference']]) reasons.push(operationReasons[answers['Operation Preference']]);
        if (speakerReasons[answers['Speaker Setup']]) reasons.push(speakerReasons[answers['Speaker Setup']]);
        if (experienceReasons[answers['Vinyl Experience']]) reasons.push(experienceReasons[answers['Vinyl Experience']]);
        const budgetReasons = {
          'Under $250': { title: 'A confident start within your budget', body: 'You set a clear spending limit, and that preference carried real weight in the match.' },
          '$250-280': { title: 'A thoughtful sweet spot', body: 'You chose a considered $250-280 target, balancing a special gift with a comfortable budget.' },
          Premium: { title: 'Chosen to feel like a special gift', body: 'You told us to prioritize the strongest overall fit over finding the lowest price.' },
          Flexible: { title: 'The right fit comes first', body: 'You kept the budget open, letting listening style and design lead the result.' }
        };
        if (budgetReasons[answers['Budget']]) reasons.push(budgetReasons[answers['Budget']]);
        if (recipientReasons[answers['Gift Recipient']]) reasons.push(recipientReasons[answers['Gift Recipient']]);
        const finishReasons = {
          Black: { title: 'A clean, timeless presence', body: 'Classic black gives the setup an easy place in almost any room.' },
          White: { title: 'Light, modern and easy to style', body: 'The clean white direction reflects the look you pictured for the space.' },
          Wood: { title: 'Warmer than another piece of tech', body: 'Wood tones help the player feel like part of the room, not just another device.' },
          'Stainless steel': { title: 'A sharper modern finish', body: 'Brushed metal brings the more precise, contemporary look you chose.' }
        };
        if (finishReasons[answers['Preferred Finish']]) reasons.push(finishReasons[answers['Preferred Finish']]);
        if (reasons.length < 2) reasons.push({ title: 'The strongest overall match', body: 'This model rose to the top when all five of your answers were considered together.' });
        return reasons.slice(0, 3);
      };
      const renderResult = () => {
        root.dataset.progress = '5';
        deckNote.textContent = 'Match complete';
        progress.hidden = false;
        step.textContent = 'Your match';
        percent.textContent = '100%';
        fill.style.width = '100%';
        back.hidden = true;
        const ranked = rankedHandles();
        const bestHandle = ranked[0];
        const alternateHandle = ranked[1];
        const best = products[bestHandle] || { title: 'Explore our turntables', url: '/collections/turntable', price: '', image: '' };
        const alternate = products[alternateHandle];
        const reasons = buildReasons(bestHandle);
        answers['Recommended Turntable'] = best.title;
        answers['Recommended Handle'] = bestHandle;
        klaviyoTrack('Completed Turntable Quiz', { 'Quiz Source': 'Turntable Finder Quiz', ...answers });
        track('tt_quiz_complete', { quiz_for: answers['Purchase Context'] || '', recommended: best.title });
        const reasonsHeading = answers['Purchase Context'] === 'Gift' ? "Why they'll love it" : 'Why it fits your listening';
        stage.innerHTML = `<div class="fyt__screen"><h2 class="fyt__result-title">Your closest match</h2><div class="fyt__match">${best.image ? `<img src="${escapeHtml(best.image)}" alt="${escapeHtml(best.title)}" loading="lazy" width="450" height="450">` : ''}<div><h3>${escapeHtml(best.title)}</h3><p class="fyt__price">${escapeHtml(best.price)}</p><a class="fyt__button" href="${escapeHtml(best.url)}">${escapeHtml(config.resultCta)} <span>→</span></a></div></div><div class="fyt__reasons"><h4>${escapeHtml(reasonsHeading)}</h4><div class="fyt__reason-list">${reasons.map((reason) => `<div class="fyt__reason"><strong>${escapeHtml(reason.title)}</strong><span>${escapeHtml(reason.body)}</span></div>`).join('')}</div></div>${alternate ? `<a class="fyt__alternate" href="${escapeHtml(alternate.url)}">Also worth comparing: <strong>${escapeHtml(alternate.title)}</strong> →</a>` : ''}<div class="fyt__email"><h3>${escapeHtml(config.emailHeading)}</h3><p>${escapeHtml(config.emailPrompt)}</p><label for="fyt-email-${root.dataset.sectionId}">Email address</label><div class="fyt__email-row"><input id="fyt-email-${root.dataset.sectionId}" type="email" autocomplete="email" inputmode="email" placeholder="you@email.com"><button class="fyt__button" type="button" data-fyt-email>${escapeHtml(config.emailCta)}</button></div><p class="fyt__message" role="status"></p></div></div>`;
        stage.querySelector('[data-fyt-email]').addEventListener('click', submitEmail);
      };
      const submitEmail = () => {
        const input = stage.querySelector('input[type="email"]');
        const message = stage.querySelector('.fyt__message');
        const email = input.value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { message.textContent = 'Enter a valid email address.'; input.focus(); return; }
        const properties = { email, 'Quiz Source': 'Turntable Finder Quiz', ...answers };
        try {
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(properties);
          else { window._learnq = window._learnq || []; window._learnq.push(['identify', { '$email': email, ...properties }]); }
          if (config.klaviyoPublicKey && config.klaviyoListId) {
            fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(config.klaviyoPublicKey)}`, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Turntable Quiz', profile: { data: { type: 'profile', attributes: { email, properties } } } }, relationships: { list: { data: { type: 'list', id: config.klaviyoListId } } } } }) });
          }
        } catch (error) {}
        track('tt_quiz_lead', { recommended: answers['Recommended Turntable'] || '' });
        message.textContent = 'Saved. Check your inbox for your $20 cash coupon.';
        input.disabled = true;
        stage.querySelector('[data-fyt-email]').disabled = true;
      };
      back.addEventListener('click', () => { if (index > 0) { index -= 1; renderQuestion(); } });
      renderIntro();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
